import "../style/LeaveList.css";
import { NavLink } from "react-router-dom";

export default function LeaveList() {
  return (
    <div className="leave-page">

  <aside className="sidebar">
      {/* ===== LOGO ===== */}
      {/* <div className="sidebar-logo">
        <img src={logo} alt="OrangeHRM" />
      </div> */}

      {/* ===== MENU ===== */}
      <ul className="employee-menu">
        <li>
          <NavLink to="/search" className="menu-item">
            <span className="icon">🔍</span>
            <span>Search</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/admin" className="menu-item">
            <span className="icon">👤</span>
            <span>Admin</span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employee-list" className="menu-item">
            <span className="icon">👥</span>
            <span>PIM</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/leave-list" className="menu-item active">
            <span className="icon">📝</span>
            <span>Leave</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/time" className="menu-item">
            <span className="icon">⏱</span>
            <span>Time</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/recruitment" className="menu-item">
            <span className="icon">🎯</span>
            <span>Recruitment</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/my-info" className="menu-item">
            <span className="icon">📄</span>
            <span>My Info</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/performance" className="menu-item">
            <span className="icon">⭐</span>
            <span>Performance</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/dashboard" className="menu-item">
            <span className="icon">🏠</span>
            <span>Dashboard</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/directory" className="menu-item">
            <span className="icon">📇</span>
            <span>Directory</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/maintenance" className="menu-item">
            <span className="icon">⚙️</span>
            <span>Maintenance</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/claim" className="menu-item">
            <span className="icon">💰</span>
            <span>Claim</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/buzz" className="menu-item">
            <span className="icon">💬</span>
            <span>Buzz</span>
          </NavLink>
        </li>
      </ul>
    </aside>


      {/* ===== TOP ACTION TABS ===== */}
      <main className="main-content">
   <div className="leave-tabs">
  <NavLink to="/leave/apply" className="tab">
    Apply
  </NavLink>

  <NavLink to="/leave/my-leave" className="tab">
    My Leave
  </NavLink>

  <NavLink to="/leave/entitlements" className="tab">
    Entitlements ▾
  </NavLink>

  <NavLink to="/leave/reports" className="tab">
    Reports ▾
  </NavLink>

  <NavLink to="/leave/configure" className="tab">
    Configure ▾
  </NavLink>

  <NavLink
    to="/leave-list"
    className={({ isActive }) =>
      isActive ? "tab active" : "tab"
    }
  >
    Leave List
  </NavLink>

  <NavLink to="/leave/assign" className="tab">
    Assign Leave
  </NavLink>
</div>

      {/* ===== FILTER CARD ===== */}
      <div className="card">
        <h3>Leave List</h3>
        <hr />

        <div className="filter-grid">
          <div>
            <label>From Date</label>
            <input type="date" defaultValue="2026-01-01" />
          </div>

          <div>
            <label>To Date</label>
            <input type="date" defaultValue="2026-12-31" />
          </div>

          <div>
            <label>Show Leave with Status *</label>
            <select>
             <option value="">-- Select --</option>
<option value="Rejected">Rejected</option>
<option value="Cancelled">Cancelled</option>
<option value="Pending Approval">Pending Approval</option>
<option value="Scheduled">Scheduled</option>
<option value="Taken">Taken</option>


              
            </select>
          
          </div>

          <div>
           <label>Leave Type</label>
<select name="leaveType" id="leaveType">
  <option value="">-- Select --</option>
  <option value="casual_leave">Casual Leave (CL)</option>
  <option value="sick_leave">Sick Leave (SL)</option>
  <option value="earned_leave">Earned Leave (EL)</option>
  <option value="annual_leave">Annual Leave</option>
  <option value="maternity_leave">Maternity Leave</option>
  <option value="paternity_leave">Paternity Leave</option>
  <option value="bereavement_leave">Bereavement Leave</option>
  <option value="comp_off">Compensatory Off</option>
  <option value="optional_holiday">Optional Holiday</option>
  <option value="leave_without_pay">Leave Without Pay (LWP)</option>
  <option value="work_from_home">Work From Home (WFH)</option>
  <option value="half_day_leave">Half Day Leave</option>
  <option value="marriage_leave">Marriage Leave</option>
  <option value="study_leave">Study Leave</option>
  <option value="sabbatical_leave">Sabbatical Leave</option>
</select>

          </div>

          <div>
            <label>Employee Name</label>
            <input placeholder="Type for hints..." />
          </div>

          <div>
           <label>Sub Unit</label>
<select name="subUnit" id="subUnit">
  <option value="">-- Select --</option>
  <option value="development">Development</option>
  <option value="qa">Quality Assurance (QA)</option>
  <option value="devops">DevOps</option>
  <option value="hr">Human Resources (HR)</option>
  <option value="finance">Finance</option>
  <option value="sales">Sales</option>
  <option value="marketing">Marketing</option>
  <option value="support">Customer Support</option>
  <option value="operations">Operations</option>
  <option value="admin">Administration</option>
  <option value="it_support">IT Support</option>
  <option value="research">Research & Development</option>
  <option value="management">Management</option>
</select>

          </div>

          <div className="toggle-wrap">
            <label>Include Past Employees</label>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </div>
        </div>

        <div className="filter-footer">
          <span className="required">* Required</span>
          <div>
            <button className="btn-outline">Reset</button>
            <button className="btn-primary">Search</button>
          </div>
        </div>
      </div>

      {/* ===== TABLE CARD ===== */}
      <div className="card">
        <h3>No Records Found</h3>

        <table>
          <thead>
            <tr>
              <th><input type="checkbox" /></th>
              <th>Date</th>
              <th>Employee Name</th>
              <th>Leave Type</th>
              <th>Leave Balance (Days)</th>
              <th>Number of Days</th>
              <th>Status</th>
              <th>Comments</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {/* Empty State */}
          </tbody>
        </table>
      </div>
      </main>
    </div>
  );
}
